import React from "react";
import ComingSoon from "../shared/ComingSoon/ComingSoon";

function VideoSection() {
  return (
    <div className="mb-[100px]">
      <div className="flex justify-center items-center flex-col pt-14 pb-6 max-[481px]:pt-6">
        <ComingSoon />
      </div>
      <>
        <div className="relative w-full h-[90vh] max-[1200px]:h-[90vh] flex items-center flex-col justify-center bg-[url(/public/assets/home_bg.svg)] bg-cover bg-no-repeat bg-center">
          <img src="/assets/home_img.svg" alt="" />
        </div>
      </>
    </div>
  );
}

export default VideoSection;
